export { default } from './ClippedImage'
